import styled from 'styled-components/macro';

export const Content = styled.div`
  padding: 5.9375rem 1.25rem 1.25rem;
  @media (min-width: 992px) {
    padding: 1.25rem 1.25rem 1.25rem 5.75rem;
  }
`;
